













import { Vue, Component, Model, Prop, Watch } from 'vue-property-decorator'

import service, { DemoRole } from '@/mock/api/demoRole'

import RemoteApiSelecter from '@/components/base/remoteApiSelecter.vue'

@Component({
  name: 'RemoteRoleSelecter',
  components: {
    RemoteApiSelecter
  }
})
export default class extends Vue {
    @Model('input')
    readonly value!:number

    @Prop({
      type: String,
      default: '选择角色'
    })
    readonly placeholder?:string

    @Prop({
      type: Boolean,
      default: false
    })
    readonly readOnly?:boolean

    curValue:number|string = ''

    @Watch('value')
    watchValue (newValue:number) {
      this.curValue = newValue
    }

    // 触发变更事件
    onDataItemChange (item:any) {
      this.$emit('input', item ? item.id : undefined)
      this.$emit('onchange', item ? item.id : undefined)
      this.$emit('onDataItemChange', item)
    }

    created () {
      this.curValue = this.value
    }

    // 显示选项的值
    displayValue (item:DemoRole) {
      return item.name
    }

    // reset选择器
    public reset () {
      let selecter = this.$refs.remoteSelecter as RemoteApiSelecter
      selecter.resetQuery()
    }

    // 通过api搜索可选择的值
    queryDataApi (query?:string) {
      return service.fetchList().then(resp => {
        return {
          data: resp.result
        }
      })
    }
}
